import React, { useState } from "react";
import { toast } from "sonner";
import { Buildings } from "@phosphor-icons/react";
import { api } from "../lib/api";
import { Input } from "./ui/input";
import { Textarea } from "./ui/textarea";

const empty = { club: "", contact: "", email: "", phone: "", location: "", members: "", message: "" };
const field = "rounded-none border-navy/20 bg-white h-12 focus-visible:ring-2 focus-visible:ring-gold focus-visible:border-gold";
const POLICY_URL = "https://tabletennis.org.nz/about-us/our-constitution-policies";

export const ClubApplyForm = () => {
  const [form, setForm] = useState(empty);
  const [agreed, setAgreed] = useState(false);
  const [loading, setLoading] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (!form.club || !form.contact || !form.email) { toast.error("Club name, contact and email are required."); return; }
    if (!agreed) { toast.error("Please confirm your club has read and agrees to the TTNZ privacy policy."); return; }
    setLoading(true);
    const message = `Club application\nClub: ${form.club}\nLocation: ${form.location || "-"}\nApprox members: ${form.members || "-"}\n\n${form.message}`;
    try {
      await api.post("/submissions", { type: "club", name: form.contact, email: form.email, phone: form.phone, message, agreed_privacy: true });
      toast.success("Application sent! We'll be in touch about joining the Te Manawa umbrella.");
      setForm(empty); setAgreed(false);
    } catch (err) { toast.error(err?.response?.data?.detail || "Something went wrong. Please try again."); }
    finally { setLoading(false); }
  };

  return (
    <form onSubmit={submit} className="space-y-5" data-testid="club-apply-form">
      <div className="grid sm:grid-cols-2 gap-5">
        <div><label className="text-sm font-medium text-navy mb-2 block">Club name *</label>
          <Input data-testid="club-name" value={form.club} onChange={set("club")} placeholder="Your club's name" className={field} /></div>
        <div><label className="text-sm font-medium text-navy mb-2 block">Contact person *</label>
          <Input data-testid="club-contact" value={form.contact} onChange={set("contact")} placeholder="Your name" className={field} /></div>
      </div>
      <div className="grid sm:grid-cols-2 gap-5">
        <div><label className="text-sm font-medium text-navy mb-2 block">Email *</label>
          <Input data-testid="club-email" type="email" value={form.email} onChange={set("email")} placeholder="you@club.co.nz" className={field} /></div>
        <div><label className="text-sm font-medium text-navy mb-2 block">Phone</label>
          <Input data-testid="club-phone" value={form.phone} onChange={set("phone")} placeholder="Optional" className={field} /></div>
      </div>
      <div className="grid sm:grid-cols-2 gap-5">
        <div><label className="text-sm font-medium text-navy mb-2 block">Location / town</label>
          <Input data-testid="club-location" value={form.location} onChange={set("location")} placeholder="e.g. Taupō" className={field} /></div>
        <div><label className="text-sm font-medium text-navy mb-2 block">Approx. members</label>
          <Input data-testid="club-members" value={form.members} onChange={set("members")} placeholder="e.g. 25" className={field} /></div>
      </div>
      <div><label className="text-sm font-medium text-navy mb-2 block">Tell us about your club</label>
        <Textarea data-testid="club-message" value={form.message} onChange={set("message")} rows={4} placeholder="A little about your club and why you'd like to affiliate with Te Manawa…" className="rounded-none border-navy/20 bg-white focus-visible:ring-2 focus-visible:ring-gold focus-visible:border-gold" /></div>
      <label className="flex items-start gap-3 bg-cream/60 border border-navy/10 p-4 cursor-pointer">
        <input type="checkbox" checked={agreed} onChange={(e) => setAgreed(e.target.checked)} data-testid="club-privacy" className="mt-1 h-4 w-4 accent-gold shrink-0" />
        <span className="text-sm text-navy/80">Have you read and agree to the <a href={POLICY_URL} target="_blank" rel="noreferrer" data-testid="club-privacy-link" className="text-navy font-semibold underline hover:text-gold">TTNZ privacy policy</a>? Our club and its members agree to abide by it and to how personal information is collected, used, stored and disclosed. *</span>
      </label>
      <button type="submit" disabled={loading} data-testid="club-submit" className="inline-flex items-center gap-2 bg-gold text-navy font-semibold px-8 py-4 rounded-sm transition-transform hover:-translate-y-0.5 disabled:opacity-60">
        <Buildings size={18} weight="fill" /> {loading ? "Sending…" : "Apply to affiliate"}
      </button>
    </form>
  );
};
